import axios from "axios";
import config from '../../config'
// const BASE_URL = "http://3.22.188.65:8080"
const BASE_URL = config.apiUrl


const GetlisteZones = async () =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
      try {
        const response = await instance.get("/rabat-zoo/zone/api/all" ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }
}

const GetZonesStats = async () =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
      try {
        const response = await instance.get("/rabat-zoo/stats/api/all" ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }
}

const AddZone = async (DataPost) =>{

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.post("/rabat-zoo/zone/api/add",DataPost ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const updateZone = async (DataPost) =>{

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.put("/rabat-zoo/zone/api/update",DataPost ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const disableZone = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/zone/api/disable/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const removeZone = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/zone/api/remove/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const enableZone = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/zone/api/enable/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const UploadFileZone = async (formData) =>{

    const options = {
        baseURL: BASE_URL,
        headers: {
            'Content-Type': 'multipart/form-data',
          },
    }
  
    const instance = axios.create(options)
      try {
        const response = await instance.post("/rabat-zoo/zone/api/upload",formData ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }
  }



const UpdateMemberRole = async (UserId,MemberID,Role,Token) =>{
    const DataPost = {
        "UserId" : UserId,
        "MemberId" : MemberID,
        "Role" : Role
    }

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.post("/api/Members/UpdateRoleMember",DataPost ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }
}

const SaveEvaluateMember = async (userId,memberId,year,cmnt,Token) =>{
    const DataPost = {
        "UserId" : userId,
        "MemberId" : memberId,
        "Year" : year,
        "Cmnt" : cmnt
    }

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            'Authorization': `Bearer ${Token}`
        }
    }
    const instance = axios.create(options)

    try {
        const response = await instance.post("/api/Members/SaveEvaluateMember",DataPost ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }

}

const ExportDataMembers = async ( userId,filename, Token ) =>{
    

    const options = {
        baseURL: BASE_URL,
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${Token}`,
        },
    }
  
    const instance = axios.create(options)
    
    try {
        console.log("/api/Members/DownloadMembers?UserId=" + userId )
      const response = await instance.get("/api/Members/DownloadMembers?UserId=" + userId + "&filename=" + filename ); 
      return response;
    } catch (error) { 
        throw error.response 
    }
}


export {GetlisteZones,UpdateMemberRole,SaveEvaluateMember,ExportDataMembers,AddZone,UploadFileZone,updateZone, disableZone, enableZone,removeZone,GetZonesStats}
